import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";

export interface UserRoleType {
  id: string;
  nome: string;
  codigo: string;
  descricao: string;
  ordem: number;
  atribuivel: boolean;
  inativo: boolean;
  profissionalSaude: boolean;
}

export class UserRoleService extends GenericService<string> {
  readonly URI: string = "Perfil";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getAllRoles() {
    return await super.get<AxiosResponse<UserRoleType[]>>();
  }

  public async getAllUsersWithRoles() {
    return await super.getByResource("PessoaEmpresa", { PageSize: 1000 });
  }

  public async getUsersByNameOrCpf(query: string) {
    return await super.getByResource("PessoaEmpresa", {
      PageSize: 500,
      Text: query,
    });
  }

  public async getByPersonId(pessoaId: string) {
    return await super.getByResource("PessoaEmpresa", {
      PageSize: 500,
      PessoaId: pessoaId,
    });
  }

  public async assignRolesToUser(body: any) {
    return await super.putByResource(body, "PessoaEmpresa");
  }
}
